import { Link } from 'react-router-dom';

export function AboutPage() {
  return (
    <div className="mx-auto max-w-2xl p-8">
      <h1 className="text-2xl font-bold text-gray-900">Despre</h1>
      <p className="mt-2 text-gray-600">
        Aceasta este o rută de exemplu care demonstrează navigarea cu React Router.
      </p>
      <Link to="/" className="mt-4 inline-block text-sm text-blue-600 underline">
        Înapoi acasă
      </Link>
    </div>
  );
}
